import PropTypes from 'prop-types';
import React from 'react';
import { t } from '../../../../modules/infra/i18n';

const DownloadScheduleHistoryButton = ({
  disabled,
  downloadHistory,
}) => (
  <div className="u-inline-block u-float-right u-mr+">
    <button
      className="c-btn c-btn--primary c-btn--small"
      disabled={disabled}
      onClick={downloadHistory}
      type="button"
    >
      {t('barber:schedule.history_button')}
    </button>
  </div>
);

DownloadScheduleHistoryButton.propTypes = {
  downloadHistory: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

DownloadScheduleHistoryButton.defaultProps = {
  disabled: false,
};

export default DownloadScheduleHistoryButton;
